// app types user role
export const ADMIN = 'ADMIN';
export const ECE = 'COUNSELOR';
export const TEACHER = 'TEACHER';
export const PARENT = 'PARENT';
export const STUDENT = 'STUDENT';
export const ASSISTANT = 'ASSISTANT';

// rbac rule type
export const PAGES = 'page';
export const COMPONENTS = 'component';

// modebup comment state
export const COMMENT_OPEN = 'OPEN';
export const COMMENT_CLOSED = 'CLOSED';

// useSelectedResponses hook
export const ADD_RESPONSE = 'ADD_RESPONSE';
export const REMOVE_RESPONSE = 'REMOVE_RESPONSE';
export const RESET_RESPONSES = 'RESET_RESPONSE';
